/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_AdsInputs */

const en_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Ads`)
};

const ar_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة الإعلانات`)
};

const de_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigen entfernen`)
};

const es_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina los anuncios`)
};

const fr_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les publicités`)
};

const it_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi annunci`)
};

const ja_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告の削除`)
};

const ko_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`광고 제거`)
};

const pt_br_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remoção de anúncios`)
};

const ru_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление рекламы`)
};

const th_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบโฆษณา`)
};

const tr_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reklamları Kaldır`)
};

const zh_cn_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无广告`)
};

const zh_tw_no_ads = /** @type {(inputs: No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無廣告`)
};

/**
* | output |
* | --- |
* | "Remove Ads" |
*
* @param {No_AdsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const no_ads = /** @type {((inputs?: No_AdsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_AdsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_ads(inputs)
	if (locale === "ar") return ar_no_ads(inputs)
	if (locale === "de") return de_no_ads(inputs)
	if (locale === "es") return es_no_ads(inputs)
	if (locale === "fr") return fr_no_ads(inputs)
	if (locale === "it") return it_no_ads(inputs)
	if (locale === "ja") return ja_no_ads(inputs)
	if (locale === "ko") return ko_no_ads(inputs)
	if (locale === "pt_br") return pt_br_no_ads(inputs)
	if (locale === "ru") return ru_no_ads(inputs)
	if (locale === "th") return th_no_ads(inputs)
	if (locale === "tr") return tr_no_ads(inputs)
	if (locale === "zh_cn") return zh_cn_no_ads(inputs)
	return zh_tw_no_ads(inputs)
});